export default __webpack_public_path__ + "static/logo_vertical_colour_lockup-bb3462ca9eaf4cf88b8d9c61ed810a4e.svg";